export type SearchValidationResult = {
    isValid: boolean;
    inputType:
    | "ALPHA"
    | "NUMERIC"
    | "EMAIL"
    | "PAN"
    | "ORDER_ID"
    | "TXN_ID"
    | "MERCHANT_ID"
    | "MIXED";
    message?: string;
};


export const validateCustomerSearchInput = (
    value: string
): SearchValidationResult => {
    const trimmed = value.trim();

    // ❌ Empty
    if (!trimmed) {
        return { isValid: false, inputType: "MIXED" };
    }

    // Minimum length
    if (trimmed.length < 4) {
        return {
            isValid: false,
            inputType: "MIXED",
            message: "Please enter at least 4 characters",
        };
    }
    // ✅ CleverPe Order ID → CLEVERPE_123456_789
    const cleverpeOrderFullRegex = /^CLEVERPE_\d+_\d+$/i;
    const cleverpeOrderPartialRegex = /^CLEVERPE_/i;

    if (cleverpeOrderPartialRegex.test(trimmed)) {
        if (!cleverpeOrderFullRegex.test(trimmed)) {
            return {
                isValid: false,
                inputType: "ORDER_ID",
                message: "Please enter full Order ID",
            };
        }

        return {
            isValid: true,
            inputType: "ORDER_ID",
        };
    }

    // ✅ CP ID → CP1234567890
    const cpIdFullRegex = /^CP\d+$/i;
    const cpIdPartialRegex = /^CP/i;

    if (cpIdPartialRegex.test(trimmed)) {
        if (!cpIdFullRegex.test(trimmed)) {
            return {
                isValid: false,
                inputType: "ORDER_ID",
                message: "Please enter full Order ID",
            };
        }

        return {
            isValid: true,
            inputType: "ORDER_ID",
        };
    }

    // ✅ Merchant ID → CLVRPE_MS01359
    const merchantIdFullRegex = /^CLVRPE_MS\d+$/i;
    const merchantIdPrefixRegex = /^CLVRPE_MS/i;

    if (merchantIdPrefixRegex.test(trimmed)) {
        if (!merchantIdFullRegex.test(trimmed)) {
            return {
                isValid: false,
                inputType: "MERCHANT_ID",
                message: "Please enter full Merchant ID",
            };
        }

        return {
            isValid: true,
            inputType: "MERCHANT_ID",
        };
    }


    // ✅ CASHe Transaction ID → CASHe_1768898942029
    const casheTxnFullRegex = /^CASHe_\d{10,}$/i; // at least 10 digits
    const casheTxnPrefixRegex = /^CASHe_/i;

    if (casheTxnPrefixRegex.test(trimmed)) {
        if (!casheTxnFullRegex.test(trimmed)) {
            return {
                isValid: false,
                inputType: "TXN_ID",
                message: "Please enter full transaction ID",
            };
        }

        return {
            isValid: true,
            inputType: "TXN_ID",
        };
    }




    // ✅ PAN Number → ABCDE1234F (ONLY full PAN)
    const panFullRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i;

    if (panFullRegex.test(trimmed)) {
        return {
            isValid: true,
            inputType: "PAN",
        };
    }



    // ✅ Email → example@domain.com
    const emailFullRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (trimmed.includes("@")) {
        if (!emailFullRegex.test(trimmed)) {
            return {
                isValid: false,
                inputType: "EMAIL",
                message: "Please enter full email address",
            };
        }

        return {
            isValid: true,
            inputType: "EMAIL",
        };
    }



    // ❌ Only numbers → Mobile
    if (/^\d+$/.test(trimmed)) {
        if (trimmed.length === 10) {
            return {
                isValid: true,
                inputType: "NUMERIC",
            };
        }

        return {
            isValid: false,
            inputType: "NUMERIC",
            message: "Please enter full mobile number",
        };
    }

    // ✅ Name (alphabets + spaces)
    if (/^[a-zA-Z\s]+$/.test(trimmed)) {
        return {
            isValid: true,
            inputType: "ALPHA",
        };
    }

    // ❌ Invalid / junk
    return {
        isValid: false,
        inputType: "MIXED",
        message: "Invalid search input",
    };
};
